import {
  fetchAccountSwitcherInit,
  AccountSwitcherInit,
  RedirectError,
} from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

export interface GetAccountSwitcherInitOptions {
  headers?: Record<string, string>;
}

export default async (
  options?: GetAccountSwitcherInitOptions,
): Promise<AccountSwitcherInit> => {
  try {
    return await fetchAccountSwitcherInit({
      ...ChromeInternalApiRequestConfig,
      ...(options?.headers ? { headers: options.headers } : {}),
    });
  } catch (error: any) {
    // redirect to redirectUrl if the API returns 302
    if (
      window &&
      error &&
      error.type === RedirectError.TYPE &&
      error.redirectUrl
    ) {
      window.location.replace(error.redirectUrl);
    }
    throw error;
  }
};
